// extracted by mini-css-extract-plugin
export default {"shimmer_container":"ProfileLayoutSidebarShimmer_shimmer_container__34kHO"};